export default "__VITE_ASSET__00d945ca__"